/** @提及面板懒加载壳（21d-3 首屏瘦身；StickerPanelLazy 同构） */
import { useLazyModule } from './useLazyModule';
import type * as Mod from './MentionPanel';
import type { ComponentProps } from 'preact';

type Props = ComponentProps<typeof Mod.MentionPanel>;

export function MentionPanelLazy(props: Props) {
  const { mod } = useLazyModule(() => import('./MentionPanel'));
  if (mod === null) return null;
  return <mod.MentionPanel {...props} />;
}
